(ns app.views
  (:require [app.dashboard.events :as wevents]
            [app.events :as events]
            [app.routes :as routes]
            [app.subs :as subs]
            [day8.re-frame.tracing :refer [fn-traced]]
            [jwt-decode]
            [re-com.core :as re-com :refer [at v-box]]
            [re-frame.core :as re-frame :refer [dispatch]]
            [re-posh.core :as re-posh :refer [reg-event-ds]]
            [pushy.core :as pushy]
            [react :as react]
            [reagent.core  :as reagent]
            [clojure.walk]))


(defn responsive-screen-width [secondary-screen-size]
  (if (< (.-innerWidth js/window) 800)
    "100%"
    secondary-screen-size))

(defn auto-authenticate [token selected-workspace active-panel workspace-data]
  (if (< (* 1000 (:exp (js->clj (jwt-decode token) :keywordize-keys true))) (.getTime (js/Date.)))
    (re-frame/dispatch [::events/navigate [:login]])
    [(re-frame/dispatch [::events/auto-authenticate-user  {:workspace-id selected-workspace :token token}])
     (when (or (= active-panel :login-panel) (= active-panel :home-page-panel) (= active-panel :sign-up-panel))
       (re-frame/dispatch [::events/navigate [:dashboard]]))]))

(reg-event-ds
 ::add-workspace
 (fn-traced [_ [_ val]]
            [[:db/add 1 :selected-workspace/id val]]))
(reg-event-ds
 ::add-folder
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/id (:folder-id val)]
             [:db/add 3 :selected-folder/order (:order val)]]))

(def routerfun
  (fn [url]
    (routes/navigate-fun! url)))

(defn react-comp [active-panel workspace-data workspaces]
  (let [token (wevents/get-token)]
    (react/useEffect (fn [] 
                       (when-not (= active-panel :strive-forms-panel)
                         (if (and (nil? token) (or (not= active-panel :home-page-panel) (not= active-panel :login-panel) (not= active-panel :sign-up-panel) (not= active-panel :strive-forms-panel)))
                           (re-frame/dispatch [::events/navigate [:login]])
                           (auto-authenticate token (:selected-workspace/id workspace-data) active-panel workspaces)))
                       (fn [])))
    [:span]))

(defn main-panel []
  (let [active-panel (re-frame/subscribe [::subs/active-panel])
        workspace-data  @(re-posh/subscribe [::subs/selected-workspace-data])
        workspaces @(re-posh/subscribe [::subs/workspace-data])
        folder-id (:folder-id (:route-params  (routes/parse (-> js/window .-location .-pathname))))
        order-of-folder (some #(when (= folder-id (:workspace_id %)) (:order %)) (:selected-workspace/folders workspace-data))]
    (reagent/create-class
     {:reagent-render
      (fn []
        (if (and (nil? (:workspace/data workspaces)) (or (= @active-panel :trash-view-panel) (= @active-panel :dashboard-view-panel)))
          [(re-frame/dispatch [::wevents/get-workspaces])
           (dispatch [::add-workspace (:id (:route-params  (routes/parse (-> js/window .-location .-pathname))))])]
          (if (= @active-panel :folder-view-panel)
            [(re-frame/dispatch [::wevents/get-workspaces])
             (dispatch [::add-workspace (:id (:route-params  (routes/parse (-> js/window .-location .-pathname))))])
             (re-frame/dispatch [::wevents/get-folders (:id (:route-params  (routes/parse (-> js/window .-location .-pathname))))])
             (dispatch [::add-folder
                        {:folder-id (:folder-id (:route-params  (routes/parse (-> js/window .-location .-pathname))))
                         :order order-of-folder}])]))
        (.addRouter (-> js/window .-CommandBar) routerfun)
        [:div
         (when-not  (or (= @active-panel :strive-forms-panel) (nil? @active-panel))
           [:f> react-comp @active-panel workspace-data workspaces])
         [v-box
          :src      (at)
          :height   "100%"
          :children [(routes/panels @active-panel)]]])})))
